import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { Group as GroupIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  broadcastMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginTop: 8,
  },
  broadcastInfo: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function BroadcastMessage({ message, fmtTimeID }) {
  const classes = useStyles();
  const text = message?.content?.text?.trim();

  return (
    <Box>
      <Typography variant="body2">{text}</Typography>
      <Box className={classes.broadcastMeta}>
        <Box className={classes.broadcastInfo}>
          <GroupIcon style={{ width: 14, height: 14, marginRight: 4, color: '#128c7e' }} />
          <Typography variant="caption" color="textSecondary">
            Broadcast Message
          </Typography>
          <Box mx={1} color="#bdbdbd" fontSize={18} fontWeight={700} component="span">
            &middot;
          </Box>
          <Typography variant="caption" color="textSecondary">
            sent to {message.content?.recipients?.length || 0} contacts
          </Typography>
        </Box>
        <Typography variant="caption" color="textSecondary">
          {fmtTimeID(message.timestamp)}
        </Typography>
      </Box>
    </Box>
  );
}